import * as React from 'react';
import styles from './index.less';
import FComponentsLib from '@freelog/components-lib';
import { FI18n } from '@freelog/tools-lib';
import { connect } from 'dva';
import { ConnectState, CollectionCreatorPageModelState } from '@/models/connect';
import { Dispatch } from 'redux';
import {
  OnChange_step1_resourceName_Action,
  OnChange_step1_resourceType_Action,
  OnClick_step1_createBtn_Action,
  OnVerify_step1_resourceName_Action,
  ChangeAction,
} from '@/models/collectionCreatorPage';
import * as AHooks from 'ahooks';
import FHotspotTooltip, { fSetHotspotTooltipVisible } from '@/components/FHotspotTooltip';
import FResourceTypeInput4 from '@/components/FResourceTypeInput4';
import FIcons from '@/components/FIcons';
import FInput_PinyinSafeTextCounter from '@/components/FInput_PinyinSafeTextCounter';

interface Step1Props {
  dispatch: Dispatch;
  collectionCreatorPage: CollectionCreatorPageModelState;
}

function Step1({ dispatch, collectionCreatorPage }: Step1Props) {
  const { run } = AHooks.useDebounceFn(
    () => {
      dispatch<OnVerify_step1_resourceName_Action>({
        type: 'collectionCreatorPage/onVerify_step1_resourceName',
      });
    },
    {
      wait: 300,
    },
  );

  AHooks.useDebounceEffect(
    () => {
      if (
        !(
          collectionCreatorPage.step1_resourceType === null ||
          collectionCreatorPage.step1_resourceName === '' ||
          collectionCreatorPage.step1_resourceName_errorText !== '' ||
          collectionCreatorPage.step1_resourceName_isVerify ||
          collectionCreatorPage.step1_resourceTitle === '' ||
          collectionCreatorPage.step1_resourceTitle_errorText !== ''
        )
      ) {
        // console.log();
        fSetHotspotTooltipVisible('collectionCreator.step1.createButton', {
          value: true,
          effectiveImmediately: true,
          onlyNullish: true,
        });
      }
    },
    [
      collectionCreatorPage.step1_resourceType,
      collectionCreatorPage.step1_resourceName,
      collectionCreatorPage.step1_resourceName_errorText,
      collectionCreatorPage.step1_resourceName_isVerify,
      collectionCreatorPage.step1_resourceTitle,
      collectionCreatorPage.step1_resourceTitle_errorText,
    ],
    {
      wait: 10,
    },
  );

  return (
    <>
      <div style={{ height: 40 }} />
      <div className={styles.block}>
        {/*<FComponentsLib.FContentText text={'合集类型'} type={'highlight'} />*/}
        <FComponentsLib.FContentText text={FI18n.i18nNext.t('cqr_input_type')} type={'highlight'} />
        <div style={{ height: 5 }} />
        {/*<FComponentsLib.FContentText text={'选择最贴切描述此合集的类型，其它用户会通过合集类型在资源市场中寻找他们想要的合集。'} type={'additional2'} />*/}
        <FComponentsLib.FContentText
          text={FI18n.i18nNext.tAuto('cqr_input_type_info')}
          type={'additional2'}
        />
        <div style={{ height: 20 }} />
        <FResourceTypeInput4
          value={collectionCreatorPage.step1_resourceType}
          onChange={(value) => {
            dispatch<OnChange_step1_resourceType_Action>({
              type: 'collectionCreatorPage/onChange_step1_resourceType',
              payload: {
                value: value,
              },
            });
          }}
          subjectType={'collection'}
          showAddNewType={false}
        />
        {collectionCreatorPage.step1_resourceType_errorText !== '' && (
          <>
            <div style={{ height: 5 }} />
            <div style={{ color: '#EE4040', fontSize: 12 }}>
              {collectionCreatorPage.step1_resourceType_errorText}
            </div>
          </>
        )}
      </div>
      <div style={{ height: 5 }} />
      <div className={styles.block}>
        {/*<FComponentsLib.FContentText text={'合集标题'} type={'highlight'} />*/}
        <FComponentsLib.FContentText
          text={FI18n.i18nNext.tAuto('cqr_input_title')}
          type={'highlight'}
        />
        <div style={{ height: 5 }} />
        {/*<FComponentsLib.FContentText*/}
        {/*  text={'标题直接影响商品的搜索曝光机会，建议在标题中加入品牌/内容主旨，例如，《大明风华：明朝人的城市生活》；标题长度不超过100个字符。'}*/}
        {/*  type={'additional2'}*/}
        {/*/>*/}
        <FComponentsLib.FContentText
          text={FI18n.i18nNext.tAuto('cqr_input_title_info')}
          type={'additional2'}
        />
        <div style={{ height: 20 }} />
        <FInput_PinyinSafeTextCounter
          value={collectionCreatorPage.step1_resourceTitle}
          placeholder={
            // 输入合集标题
            FI18n.i18nNext.t('cqr_input_title_hint')
          }
          style={{ width: 880 }}
          onChangeValue={(value) => {
            dispatch<ChangeAction>({
              type: 'collectionCreatorPage/change',
              payload: {
                step1_resourceTitle: value,
                step1_resourceTitle_errorText:
                  value === '' ? '请输入标题' : value.length > 100 ? '不超过100个字符' : '',
              },
            });

            const name: string = value.substring(0, 60);
            if (
              collectionCreatorPage.step1_resourceTitle ===
                collectionCreatorPage.step1_resourceName &&
              collectionCreatorPage.step1_resourceName !== name
            ) {
              run();
              dispatch<OnChange_step1_resourceName_Action>({
                type: 'collectionCreatorPage/onChange_step1_resourceName',
                payload: {
                  value: name,
                },
              });
            }
          }}
          hasError={collectionCreatorPage.step1_resourceTitle_errorText !== ''}
        />
        {collectionCreatorPage.step1_resourceTitle_errorText !== '' && (
          <>
            <div style={{ height: 5 }} />
            <div style={{ color: '#EE4040', fontSize: 12 }}>
              {collectionCreatorPage.step1_resourceTitle_errorText}
            </div>
          </>
        )}
      </div>
      <div style={{ height: 5 }} />
      <div className={styles.block}>
        <FComponentsLib.FContentText
          text={
            // 合集授权标识
            FI18n.i18nNext.tAuto('cqr_input_authid')
          }
          type={'highlight'}
        />
        <div style={{ height: 5 }} />
        <FComponentsLib.FContentText
          text={
            // 此合集在整个授权系统中的唯一标识符，一旦创建则不能更改。
            FI18n.i18nNext.tAuto('cqr_input_authid_info')
          }
          type={'additional2'}
        />
        <div style={{ height: 20 }} />
        <div className={styles.resourceName}>
          <FComponentsLib.FContentText
            text={`${collectionCreatorPage.userInfo?.userName} /`}
            style={{
              lineHeight: '38px',
              flexShrink: 0,
              display: 'inline-block',
            }}
          />
          <div style={{ flexShrink: 1 }}>
            <FInput_PinyinSafeTextCounter
              value={collectionCreatorPage.step1_resourceName}
              className={styles.FInput}
              style={{ width: 600 }}
              lengthLimit={60}
              placeholder={
                // 输入合集授权标识
                FI18n.i18nNext.t('cqr_input_authid_hint')
              }
              onChangeValue={(value) => {
                run();
                dispatch<OnChange_step1_resourceName_Action>({
                  type: 'collectionCreatorPage/onChange_step1_resourceName',
                  payload: {
                    value: value,
                  },
                });
              }}
              hasError={collectionCreatorPage.step1_resourceName_errorText !== ''}
            />

            {collectionCreatorPage.step1_resourceName_errorText === '' &&
              collectionCreatorPage.step1_resourceName !==
                collectionCreatorPage.step1_resourceName_optimized && (
                <>
                  <div style={{ height: 5 }} />
                  <div>
                    <div
                      style={{
                        color: '#44C28C',
                        fontSize: 12,
                        lineHeight: '18px',
                      }}
                    >
                      你的资源标识将自动转换为{' '}
                      <strong>{collectionCreatorPage.step1_resourceName_optimized}</strong>
                    </div>
                    <div style={{ height: 5 }} />
                    <div
                      style={{
                        color: '#E9A923',
                        fontSize: 12,
                        lineHeight: '18px',
                      }}
                    >
                      {FI18n.i18nNext.tAuto('naming_convention_resource_name')}
                    </div>
                  </div>
                </>
              )}

            {collectionCreatorPage.step1_resourceName_errorText !== '' && (
              <>
                <div style={{ height: 5 }} />
                <div style={{ color: '#EE4040', fontSize: 12 }}>
                  {collectionCreatorPage.step1_resourceName_errorText}
                </div>
              </>
            )}
          </div>
          {collectionCreatorPage.step1_resourceName_isVerify && (
            <FIcons.FLoading style={{ lineHeight: '38px', flexShrink: 0 }} />
          )}

          {!collectionCreatorPage.step1_resourceName_isVerify &&
            collectionCreatorPage.step1_resourceName !== '' &&
            collectionCreatorPage.step1_resourceName_errorText === '' && (
              <FIcons.FCheck style={{ lineHeight: '38px', flexShrink: 0 }} />
            )}
        </div>
      </div>

      <div style={{ height: 30 }} />

      <div className={styles.btn}>
        {/*{FI18n.i18nNext.tAuto('rqr_step1_btn_createnow')}*/}
        <FHotspotTooltip
          id={'collectionCreator.step1.createButton'}
          style={{ left: 32, bottom: -38 }}
          text={FI18n.i18nNext.tAuto('hotpots_cqr_createauthid')}
          onOpenChange={(o) => {
            if (o) {
              fSetHotspotTooltipVisible('collectionCreator.step1.createButton', {
                value: false,
                effectiveImmediately: false,
                onlyNullish: false,
              });
            }
          }}
        >
          <FComponentsLib.FRectBtn
            disabled={
              collectionCreatorPage.step1_resourceType === null ||
              collectionCreatorPage.step1_resourceName === '' ||
              collectionCreatorPage.step1_resourceName_errorText !== '' ||
              collectionCreatorPage.step1_resourceName_isVerify ||
              collectionCreatorPage.step1_resourceTitle === '' ||
              collectionCreatorPage.step1_resourceTitle_errorText !== ''
            }
            type={'primary'}
            onClick={() => {
              dispatch<OnClick_step1_createBtn_Action>({
                type: 'collectionCreatorPage/onClick_step1_createBtn',
              });
            }}
          >
            {FI18n.i18nNext.tAuto('cqr_step1_btn_createnow')}
          </FComponentsLib.FRectBtn>
        </FHotspotTooltip>
      </div>
    </>
  );
}

export default connect(({ collectionCreatorPage }: ConnectState) => ({
  collectionCreatorPage: collectionCreatorPage,
}))(Step1);
